const data = [
  {
    key: "1",
    firstName: "John",
    lastName: "Doe",
    startDate: "2024-10-06",
    department: "Sales",
    dateOfBirth: "1984-01-01",
    street: "123 Main St",
    city: "Birmingham",
    state: "AL",
    zipCode: "35203",
  },
  {
    key: "2",
    firstName: "Jane",
    lastName: "Smith",
    startDate: "2023-07-12",
    department: "Marketing",
    dateOfBirth: "1990-03-14",
    street: "456 Oak Ave",
    city: "Anchorage",
    state: "AK",
    zipCode: "99501",
  },
  {
    key: "3",
    firstName: "Michael",
    lastName: "Johnson",
    startDate: "2022-05-19",
    department: "Engineering",
    dateOfBirth: "1986-06-23",
    street: "789 Pine Rd",
    city: "Phoenix",
    state: "AZ",
    zipCode: "85001",
  },
  {
    key: "4",
    firstName: "Emily",
    lastName: "Davis",
    startDate: "2021-11-05",
    department: "HR",
    dateOfBirth: "1992-12-11",
    street: "234 Cedar Blvd",
    city: "Little Rock",
    state: "AR",
    zipCode: "72201",
  },
  {
    key: "5",
    firstName: "William",
    lastName: "Brown",
    startDate: "2020-02-29",
    department: "Finance",
    dateOfBirth: "1985-09-17",
    street: "567 Birch Ln",
    city: "Los Angeles",
    state: "CA",
    zipCode: "90001",
  },
  {
    key: "6",
    firstName: "Olivia",
    lastName: "Miller",
    startDate: "2023-03-21",
    department: "Sales",
    dateOfBirth: "1994-04-25",
    street: "890 Maple Dr",
    city: "Denver",
    state: "CO",
    zipCode: "80201",
  },
  {
    key: "7",
    firstName: "James",
    lastName: "Wilson",
    startDate: "2022-09-09",
    department: "Engineering",
    dateOfBirth: "1987-11-03",
    street: "123 Spruce St",
    city: "Hartford",
    state: "CT",
    zipCode: "06101",
  },
  {
    key: "8",
    firstName: "Sophia",
    lastName: "Moore",
    startDate: "2021-01-14",
    department: "Marketing",
    dateOfBirth: "1991-08-15",
    street: "456 Elm Cir",
    city: "Wilmington",
    state: "DE",
    zipCode: "19801",
  },
  {
    key: "9",
    firstName: "Benjamin",
    lastName: "Taylor",
    startDate: "2024-04-04",
    department: "HR",
    dateOfBirth: "1989-02-10",
    street: "789 Palm Ct",
    city: "Miami",
    state: "FL",
    zipCode: "33101",
  },
  {
    key: "10",
    firstName: "Isabella",
    lastName: "Anderson",
    startDate: "2023-08-18",
    department: "Finance",
    dateOfBirth: "1993-05-19",
    street: "234 Ash Dr",
    city: "Atlanta",
    state: "GA",
    zipCode: "30301",
  },
  {
    key: "11",
    firstName: "Jacob",
    lastName: "Thomas",
    startDate: "2022-07-23",
    department: "Sales",
    dateOfBirth: "1988-12-07",
    street: "567 Redwood St",
    city: "Honolulu",
    state: "HI",
    zipCode: "96801",
  },
  {
    key: "12",
    firstName: "Mia",
    lastName: "Jackson",
    startDate: "2021-06-30",
    department: "Engineering",
    dateOfBirth: "1995-01-29",
    street: "890 Cypress Rd",
    city: "Boise",
    state: "ID",
    zipCode: "83701",
  },
  {
    key: "13",
    firstName: "Alexander",
    lastName: "White",
    startDate: "2020-12-18",
    department: "HR",
    dateOfBirth: "1983-07-02",
    street: "123 Cedar Ave",
    city: "Chicago",
    state: "IL",
    zipCode: "60601",
  },
  {
    key: "14",
    firstName: "Charlotte",
    lastName: "Harris",
    startDate: "2019-10-10",
    department: "Marketing",
    dateOfBirth: "1996-03-22",
    street: "456 Pine St",
    city: "Indianapolis",
    state: "IN",
    zipCode: "46201",
  },
  {
    key: "15",
    firstName: "Daniel",
    lastName: "Martin",
    startDate: "2018-08-27",
    department: "Finance",
    dateOfBirth: "1984-06-05",
    street: "789 Spruce Ln",
    city: "Des Moines",
    state: "IA",
    zipCode: "50301",
  },
  {
    key: "16",
    firstName: "Amelia",
    lastName: "Thompson",
    startDate: "2023-05-15",
    department: "Engineering",
    dateOfBirth: "1997-10-13",
    street: "234 Oak St",
    city: "Wichita",
    state: "KS",
    zipCode: "67201",
  },
  {
    key: "17",
    firstName: "Matthew",
    lastName: "Garcia",
    startDate: "2022-11-08",
    department: "Sales",
    dateOfBirth: "1986-01-04",
    street: "567 Maple Dr",
    city: "Louisville",
    state: "KY",
    zipCode: "40201",
  },
  {
    key: "18",
    firstName: "Harper",
    lastName: "Martinez",
    startDate: "2021-09-29",
    department: "HR",
    dateOfBirth: "1992-07-23",
    street: "890 Palm Ave",
    city: "New Orleans",
    state: "LA",
    zipCode: "70112",
  },
  {
    key: "19",
    firstName: "David",
    lastName: "Robinson",
    startDate: "2020-04-14",
    department: "Marketing",
    dateOfBirth: "1987-09-11",
    street: "123 Birch Rd",
    city: "Portland",
    state: "ME",
    zipCode: "04101",
  },
  {
    key: "20",
    firstName: "Evelyn",
    lastName: "Clark",
    startDate: "2024-02-05",
    department: "Finance",
    dateOfBirth: "1994-11-06",
    street: "456 Cypress St",
    city: "Baltimore",
    state: "MD",
    zipCode: "21201",
  },
  {
    key: "21",
    firstName: "Joseph",
    lastName: "Lewis",
    startDate: "2023-11-13",
    department: "Engineering",
    dateOfBirth: "1985-04-18",
    street: "789 Cedar Ct",
    city: "Boston",
    state: "MA",
    zipCode: "02108",
  },
  {
    key: "22",
    firstName: "Avery",
    lastName: "Walker",
    startDate: "2022-03-07",
    department: "HR",
    dateOfBirth: "1991-10-20",
    street: "234 Palm Ln",
    city: "Detroit",
    state: "MI",
    zipCode: "48201",
  },
  {
    key: "23",
    firstName: "Samuel",
    lastName: "Young",
    startDate: "2021-02-19",
    department: "Sales",
    dateOfBirth: "1989-06-14",
    street: "567 Spruce Ave",
    city: "Minneapolis",
    state: "MN",
    zipCode: "55401",
  },
  {
    key: "24",
    firstName: "Ella",
    lastName: "King",
    startDate: "2020-10-22",
    department: "Marketing",
    dateOfBirth: "1993-01-12",
    street: "890 Elm St",
    city: "Jackson",
    state: "MS",
    zipCode: "39201",
  },
  {
    key: "25",
    firstName: "Lucas",
    lastName: "Wright",
    startDate: "2024-01-10",
    department: "Finance",
    dateOfBirth: "1992-05-28",
    street: "123 Oak Ct",
    city: "Kansas City",
    state: "MO",
    zipCode: "64101",
  },
  {
    key: "26",
    firstName: "Grace",
    lastName: "Scott",
    startDate: "2023-06-25",
    department: "Engineering",
    dateOfBirth: "1988-12-19",
    street: "456 Maple Ln",
    city: "Billings",
    state: "MT",
    zipCode: "59101",
  },
];

export default data;
